export var Name = 'open-back-in-stock-notification-dialog';
export var ToggleFavorite = Name;